import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";
import http from "./http-client";

const API_URL = process.env.REACT_APP_API_URL;
const IS_LOCAL =
  process.env.REACT_APP_LOCAL_FILE_SYSTEM === "true" ||
  process.env.REACT_APP_LOCAL_FILE_SYSTEM === true;
export const useGetApplicationSettings = () =>
  useMutation({
    mutationFn: () => client(`common/applicationsettings`),
  });
export const useGetImageURL = () => {
  const IS_LOCAL =
    process.env.REACT_APP_LOCAL_FILE_SYSTEM === "true" ||
    process.env.REACT_APP_LOCAL_FILE_SYSTEM === true;

  return useMutation({
    mutationFn: async (imageURL) => {
      try {
        const url = IS_LOCAL
          ? `${API_URL}/common/download/local?path=${imageURL}`
          : `${API_URL}/common/download/cloud?url=${imageURL}`;

        const response = await http.get(url, { responseType: "blob" });

        const fileBlob = response.data;
        const blob = new Blob([fileBlob], { type: fileBlob.type });
        const objectURL = URL.createObjectURL(blob);

        return objectURL;
      } catch (error) {
        console.error("Failed to fetch image:", error);

        throw new Error(
          error?.response?.data?.message ||
            "Failed to download image. Please try again."
        );
      }
    },
  });
};

export const fetchUploadedFiles = async (uploadedFiles, API_URL, IS_LOCAL) => {
  if (!uploadedFiles || uploadedFiles.length === 0) return [];

  const filePromises = uploadedFiles.map(async (elm) => {
    try {
      const response = await http.get(
        IS_LOCAL
          ? `${API_URL}/common/download/local?path=${elm.filePath}`
          : `${API_URL}/common/download/cloud?url=${elm.filePath}`,
        { responseType: "blob" }
      );

      const blob = new Blob([response.data], { type: response.data.type });
      const url = URL.createObjectURL(blob);
      return { ...elm, filePath: url };
    } catch (error) {
      console.error(
        `Failed to fetch file: ${elm.fileName}, skipping. Error:`,
        error
      );
      return { ...elm, filePath: null }; // assign null on failure
    }
  });

  return Promise.all(filePromises);
};
